import { Bot, Sparkles, X } from "lucide-react";

export const SignatureWelcomeModal = ({ open, onClose, user }) => {
  if (!open) return null;

  const handleOpenAdvisor = () => {
    window.dispatchEvent(new CustomEvent("signature-advisor-open"));
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-[#001935]/55 px-4 py-8 backdrop-blur-sm" data-testid="signature-welcome-modal-overlay">
      <div className="w-full max-w-2xl rounded-[32px] border border-[#D4AF37]/20 bg-white p-6 shadow-[0_30px_90px_rgba(0,25,53,0.28)] md:p-8" data-testid="signature-welcome-modal">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]" data-testid="signature-welcome-modal-kicker">Signature Advisor Activated</p>
            <h2 className="mt-3 font-[Cormorant_Garamond,serif] text-4xl font-bold text-[#001935]" data-testid="signature-welcome-modal-title">Welcome to the Founding 18.</h2>
            <p className="mt-4 text-sm leading-8 text-[#42566f]" data-testid="signature-welcome-modal-description">Your boutique URL is public, your inventory is eligible for marketplace discovery, and lead tracking is now active across the platform.</p>
          </div>
          <button className="rounded-full border border-[#001935]/10 p-3 text-[#001935] transition hover:bg-[#fffaf1]" data-testid="signature-welcome-modal-close-button" onClick={onClose} type="button">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2">
          <div className="rounded-[24px] border border-[#D4AF37]/20 bg-[#fffaf1] p-5" data-testid="signature-welcome-modal-portal-card">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]">Your live URL</p>
            <p className="mt-3 break-all text-lg font-semibold text-[#001935]" data-testid="signature-welcome-modal-url">sgpropportal.com/agent/{user?.subdomain_slug || "your-name"}</p>
          </div>
          <div className="rounded-[24px] border border-[#D4AF37]/20 bg-[#fffaf1] p-5" data-testid="signature-welcome-modal-feature-card">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]">What just activated</p>
            <div className="mt-3 space-y-2 text-sm leading-7 text-[#42566f]">
              <p>• Signature Advisor ready for live inventory conversations</p>
              <p>• Global marketplace eligibility and district intelligence active</p>
              <p>• Admin lead tracking and white-label dashboard activated instantly</p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <button className="gold-button" data-testid="signature-welcome-modal-primary-button" onClick={handleOpenAdvisor} type="button">
            <Bot className="mr-2 h-4 w-4" /> Meet Your Signature Advisor
          </button>
          <button className="outline-button" data-testid="signature-welcome-modal-secondary-button" onClick={onClose} type="button">
            <Sparkles className="mr-2 h-4 w-4" /> Explore Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};